import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// components

import Navbar from "components/Navbars/AuthNavbar.js";
import FooterSmall from "components/Footers/FooterSmall.js";

// views

import Login from "views/auth/Login.js";
import Register from "views/auth/Register.js";

export default function Auth() {
  return (
    <>
   <section className="header pt-16 flex justify-center h-60vh max-h-860-px bg-lightBlue-200" >
        <div className="flex items-end">
          <img
            src={require("assets/img/bucked.png").default}
            alt="..."
            style={{ width: "200px", height: "auto" }}
          />
        </div>
      </section>
      <main>
      
       
    
          <Switch>
            <Route path="/auth/login" exact component={Login} />
            <Route path="/auth/register" exact component={Register} />
            <Redirect from="/auth" to="/auth/login" />
          </Switch>
          <FooterSmall absolute />
      
      </main>
    </>
  );
}
